var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "f7-page",
    [
      _c(
        "b-container",
        {
          staticClass:
            "main-content homepageBackgroundImage icon-homepage-button-request-payment",
          style: _vm.backgroundImg,
          attrs: { fluid: "" },
        },
        [
          _c(
            "b-row",
            { staticClass: "showLargeScreenOnly homepageTextBloc1" },
            [
              _c(
                "b-col",
                { attrs: { sm: "12" } },
                [
                  _c(
                    "transition",
                    { attrs: { name: "slide-fade-title", appear: "" } },
                    [
                      _c(
                        "div",
                        { staticClass: "homepageTitle homepageTitleText" },
                        [
                          _c("img", {
                            staticStyle: { "margin-left": "-50px" },
                            attrs: {
                              width: "450px",
                              height: "22%",
                              src: _vm.MrBgLogo,
                              alt: "mr_logo_green",
                            },
                          }),
                          _c("span", { staticClass: "big-title" }, [
                            _vm._v("Remittance"),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "showSmallScreenOnly homepageTextBloc1" },
            [
              _c(
                "b-col",
                { attrs: { sm: "12" } },
                [
                  _c(
                    "transition",
                    { attrs: { name: "slide-fade-title", appear: "" } },
                    [
                      _c(
                        "div",
                        { staticClass: "homepageTitle homepageTitleText" },
                        [
                          _c("center", [
                            _c("img", {
                              attrs: {
                                width: "450px",
                                height: "22%",
                                src: _vm.MrBgLogo,
                                alt: "mr_logo_green",
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "big-title" }, [
                            _vm._v("Remittance"),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "slide-fade-title", appear: "" } },
            [
              _c(
                "b-row",
                { staticClass: "homepageCards" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex flex-row",
                      attrs: { cols: "2", offset: "4" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "homeCardBody homeCardBody-1 text-center",
                        },
                        [
                          _c("i", {
                            staticClass: "fa-light fa-download",
                            staticStyle: { "font-size": "50px" },
                          }),
                          _vm._v(" "),
                          _c("h4", [
                            _vm._v(_vm._s(_vm.$t("Homepage.import_file"))),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "d-flex flex-row", attrs: { cols: "2" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "homeCardBody homeCardBody-3 text-center",
                        },
                        [
                          _c("i", {
                            staticClass: "fa-light fa-arrows-rotate",
                            staticStyle: { "font-size": "50px" },
                          }),
                          _vm._v(" "),
                          _c("h4", [
                            _vm._v(_vm._s(_vm.$t("Homepage.decision"))),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "d-flex flex-row", attrs: { cols: "2" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "homeCardBody homeCardBody-2 text-center",
                        },
                        [
                          _c("i", {
                            staticClass: "fa-light fa-magnifying-glass",
                            staticStyle: { "font-size": "50px" },
                          }),
                          _vm._v(" "),
                          _c("h4", [
                            _vm._v(_vm._s(_vm.$t("Homepage.consultations"))),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "homepageTextBloc3" },
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12" } },
                    [
                      _c(
                        "transition",
                        { attrs: { name: "slide-fade-title", appear: "" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "homepageSubTitle homepageSubTitleText",
                            },
                            [
                              _c("img", {
                                staticClass: "homepageSubTitleLogo",
                                attrs: { src: _vm.imgLogo },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }